// -- == //
import AppTable from 'components/appTable';
import Empty from 'components/empty';
import RowAction from 'components/rowAction';
import Value from 'components/value';
import { MISSING } from 'common/helpers/format';

import * as S from './styles';

interface IProps {
  data: any[];
  setValues: any;
  values: any;
}

const TrashIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
  </svg>
);

const PeopleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20a6 6 0 0 1 12 0" />
    <path d="M19 8v6M22 11h-6" />
  </svg>
);

/*
 * Who the notification is going to.
 *
 * The card this drew for itself had a `Users` heading of its own inside a
 * second `PanelBoxLayout`, so the tab body held a card inside a card. It is a
 * bordered table under a subhead now — the design's own treatment for the
 * selected list beside a recipient picker.
 */
export default function NoticationUserTable({ data, setValues, values }: IProps) {
  return (
    <S.Frame>
      <AppTable
        headers={[
          { id: 1, key: 'id', title: 'ID', dir: 'left', width: 72 },
          { id: 2, key: 'supporter', title: 'Name', dir: 'left' },
          { id: 4, key: 'jobTitle', title: 'Job Title', dir: 'left', width: 180 },
          { id: 6, key: 'management', title: '', type: 'actions', width: 56 }
        ]}
        data={data}
        empty={
          <Empty
            size="sm"
            icon={<PeopleIcon />}
            title="No one selected yet"
            text="Pick people from the recipients box above and they appear here."
          />
        }
        altanfeethiFields={{
          id: (item: any) => (
            <S.Div className="text-left">
              <Value mono>{item?.id}</Value>
            </S.Div>
          ),

          supporter: (item: any) => (
            <S.Div className="text-left captal">
              <Value fallback={MISSING.provided}>{item?.displayName}</Value>
            </S.Div>
          ),
          jobTitle: (item: any) => (
            <S.Div className="text-left captal">
              <Value fallback={MISSING.none}>{item?.jobTitle}</Value>
            </S.Div>
          ),
          management: (item: any) => (
            <RowAction
              label={`Remove ${item?.displayName || 'this person'}`}
              onClick={() => {
                setValues({
                  ...values,
                  users: values.users.filter((item2: any) => item2.id !== item.id) as any
                });
              }}
            >
              <TrashIcon />
            </RowAction>
          )
        }}
      />
    </S.Frame>
  );
}
